import { AppRoutePathModel, RoutePathConfig, StaticRoutePath } from '../model/Route'
import { DYNAMIC_ROUTE_START } from './router.constant'
import { Id } from '../../../model/Id'

export const appHomePath = '/'

function getPath(subPath = '') {
  return appHomePath + subPath
}

const prefixes = {
  onBoarding: getPath('on-boarding'),
  auth: getPath('auth'),
  profile: getPath('profile'),
  knowledge: getPath('knowledge'),
  eLearning: getPath('e-learning'),
  get subscription() {
    return `${this.profile}/subscription`
  },
  get payment() {
    return `${this.profile}/payment`
  },
  get paymentHistory() {
    return `${this.payment}/history`
  },
  get faq() {
    return `${this.knowledge}/faq`
  },
  controlpanel: getPath('controlpanel'),
  userDashboard: getPath('user-dashboard'),
  myTeam: getPath('my-team'),
  projectBuilder: getPath('project-builder'),
}

export const appRoutePath: AppRoutePathModel = {
  // forum
  forum: getPath('forum'),

  // villkor
  villkor: getPath('villkor'),

  // payroll
  payroll: getPath('payroll'),

  // maintenance
  maintenance: getPath('maintenance'),

  // e-learning
  eLearning: getPath('e-learning'),
  platformArticle(id: string) {
    return `${this.eLearning}/${id}`
  },
  learning: getPath('learning'),
  learningCategory(key: string) {
    return `${this.learning}/${key}`
  },
  course: getPath('course'),
  myCourses: getPath('my-courses'),

  // company-page
  companyPage: getPath('company'),
  companyPageEditItem: getPath('company-edit'),

  // blog
  blog: getPath('blog'),
  blogArticle(id: string) {
    return `${this.blog}/${id}`
  },

  // knowledge
  faq: prefixes.faq,
  faqGroup(id: Id) {
    return `${this.faq}/${id}`
  },
  get additionalServices() {
    return `${prefixes.knowledge}/additional-services`
  },

  // auth
  get authHome() {
    return `${prefixes.auth}/home`
  },
  get forgotPassword() {
    return `${prefixes.auth}/forgot-password`
  },
  get resetPassword() {
    return `${prefixes.auth}/reset-password`
  },
  get signIn() {
    return `${prefixes.auth}/sign-in`
  },
  get verifyAccount() {
    return `${prefixes.auth}/verify-account`
  },
  get ssoVerify() {
    return `${prefixes.auth}/sso-verify`
  },

  // profile
  get profileInfo() {
    return `${prefixes.profile}/info`
  },
  get editProfile() {
    return `${prefixes.profile}/edit`
  },
  get editPositions() {
    return `${prefixes.profile}/positions`
  },
  subscription: prefixes.subscription,
  paymentHistory: prefixes.paymentHistory,
  get activateLearning() {
    return `${prefixes.subscription}/activate-learning`
  },

  // on boarding
  get signUp() {
    return `${prefixes.onBoarding}/sign-up`
  },
  get companySignUp() {
    return `${prefixes.onBoarding}/company`
  },

  // B2B
  login(id: string) {
    return `login/${id}`
  },
  get controlpanelUsers() {
    return `${prefixes.controlpanel}/users`
  },
  get controlpanelModules() {
    return `${prefixes.controlpanel}/modules`
  },
  get controlpanelOrganisation() {
    return `${prefixes.controlpanel}/organisation`
  },
  get controlpanelSystem() {
    return `${prefixes.controlpanel}/system`
  },

  // skill-analysis
  skillAssessment: getPath('skill-assessment'),

  // dashboard
  userDashboard: prefixes.userDashboard,

  // my-team
  myTeam: `${prefixes.myTeam}/overview`,
  myTeamRoles(levelId: string) {
    return `${this.myTeam}/roles/${levelId}`
  },
  MyTeamUserDetails(userId: string) {
    return `${this.myTeam}/user/${userId}`
  },
  myTeamDashboard: `${prefixes.myTeam}/dashboard`,
  myTeamSkillGaps(skillName = '') {
    return skillName ? `${prefixes.myTeam}/skill-gaps/${skillName}` : `${prefixes.myTeam}/skill-gaps`
  },
  myTeamLearning: `${prefixes.myTeam}/learning`,
  
  // performance-review
  myTeamPerformance: `${prefixes.myTeam}/performance`,
  myTeamPerformanceCreate: `${prefixes.myTeam}/performance/create`,
  
  // project-builder
  projectBuilder: `${prefixes.projectBuilder}/overview`,
  projectBuilderCreate: `${prefixes.projectBuilder}/create`,
} as const

export function getDynamicRouteConfigPath(path: StaticRoutePath) {
  return `${DYNAMIC_ROUTE_START}${path}`
}

export const routePathConfig: RoutePathConfig = {
  ...appRoutePath,
  blogArticle: appRoutePath.blogArticle(getDynamicRouteConfigPath('id')),
  platformArticle: appRoutePath.platformArticle(getDynamicRouteConfigPath('id')),
  learningCategory: appRoutePath.learningCategory(getDynamicRouteConfigPath('key')),
  faqGroup: appRoutePath.faqGroup(getDynamicRouteConfigPath('faqGroupName')),
  login: appRoutePath.login(getDynamicRouteConfigPath('id')),
  myTeamRoles: appRoutePath.myTeamRoles(getDynamicRouteConfigPath('levelId')),
  MyTeamUserDetails: appRoutePath.MyTeamUserDetails(getDynamicRouteConfigPath('userId')),
  myTeamSkillGaps: appRoutePath.myTeamSkillGaps(`${getDynamicRouteConfigPath('skillName')}?`),
} as const
